import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  IconButton,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import {
  FilmIcon,
  MusicalNoteIcon,
  BookOpenIcon,
} from "@heroicons/react/24/outline";
import { updateItem } from "../store/Reducers/itemReducer";
import { useReduxStore } from "../hooks/useReduxStore";
import { deepCopy, returnSubCategoryName } from "../helper/helper";
export default function MyItemsCard({
  image,
  title,
  id,
  description,
  rating,
  type = "movie",
  views,
  item = {},
  category,
  dark = false,
}) {
  const { dispatch } = useReduxStore();
  const onItemClick = () => {
    dispatch(updateItem({ itemDetail: deepCopy(item) }));
    navigate(
      {
        pathname: "/Detail",
        search: `?id=${item?.id}`,
      },
      { state: { ...item } }
    );
  };
  const navigate = useNavigate();
  const dummuImageUrl =
    "https://images.unsplash.com/photo-1499696010180-025ef6e1a8f9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";
  return (
    <Card
      onClick={onItemClick}
      className={`border-[0.5px] rounded-md w-full max-w-[40rem] flex-row md:max-w-[38rem] lg:max-w-[42rem] xl:max-w-[50rem] shadow-md transition-all duration-300 hover:cursor-pointer md:my-2 ${
        dark
          ? "border-zinc-800/80 bg-zinc-900/30 hover:bg-zinc-900/60 hover:border-zinc-700/50"
          : "border-orange-100 bg-white hover:bg-orange-50/50"
      }`}
    >
      <CardHeader
        className={`m-0 w-2/5 shrink-0 rounded-md rounded-r-none ${dark ? "border-r border-zinc-800" : ""}`}
        floated={false}
        color="blue-gray"
      >
        <img
          className="h-32 w-full object-cover md:h-[10rem] lg:h-[11rem] xl:h-[12rem]"
          src={image || dummuImageUrl}
          alt="item image"
        />
        <div className="to-bg-black-10 absolute inset-0 h-full w-full bg-gradient-to-tr from-transparent via-transparent to-black/60" />
      </CardHeader>
      <CardBody className="px-3 pt-2 pb-4 md:pt-5 flex flex-col justify-between">
        <div>
          <Typography
            variant="h5"
            className={`font-bold text-sm md:text-base line-clamp-1 ${dark ? "text-white" : "text-blue-gray-900"}`}
          >
            {title || "Wooden House, Florida"}
          </Typography>
          <Typography
            variant="paragraph"
            className={`line-clamp-2 mt-2 md:line-clamp-2 text-xs md:text-sm md:mt-3 ${
              dark ? "text-zinc-400" : "text-gray-600"
            }`}
          >
            {description ||
              "Enter a freshly updated and thoughtfully furnished peaceful home surrounded by ancient trees, stone walls, and open meadows."}
          </Typography>
        </div>
        <div className="mt-3 md:mt-5 flex gap-3 items-center">
          {type === "Video" && <FilmIcon className="h-5 w-5 text-secondary animate-pulse" />}
          {type === "Audio" && (
            <MusicalNoteIcon className="h-5 w-5 text-secondary animate-pulse" />
          )}
          {type === "Book" && (
            <BookOpenIcon className="h-5 w-5 text-secondary animate-pulse" />
          )}

          <Typography
            className={`flex items-center gap-1.5 font-semibold text-xs ${
              dark ? "text-zinc-300" : "text-blue-gray-800"
            }`}
          >
            {returnSubCategoryName(category)}
          </Typography>
        </div>
      </CardBody>
    </Card>
  );
}
